import styles from "@styles/pages/reports/reports.module.scss";
import { useState } from "react";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export default function ComboFilters({
  options,
  selectedOption,
  onSelect,
  design = "one",
}) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={css({ comboFilters: true, [design]: true })}>
      <div
        className={css({
          selectedCategory: true,
          collapsed: collapsed,
        })}
        onClick={() => setCollapsed(!collapsed)}
      >
        <p>{selectedOption?.name}</p>
        <i className="fas fa-chevron-down" />
      </div>

      <div
        className={css({
          collapsedCategories: true,
          in: collapsed,
          out: !collapsed,
        })}
      >
        <ul className={styles.options}>
          {(options || []).map((o) => (
            <li
              key={o.name}
              onClick={() => {
                onSelect(o);
                setCollapsed(false);
              }}
            >
              {o.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
